import { Inject, Injectable } from '@angular/core';
import { USERS_REPOSITORY, UsersRepository } from '@core/repositories/users.repository';
import { User } from '@shared/interfaces/user';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  constructor(
    @Inject(USERS_REPOSITORY)
    protected repository: UsersRepository
  ) {}

  getItems(): Observable<any> {
    return this.repository.getItems();
  }

  add(user: User): Observable<any> {
    return this.repository.add(user);
  }

  edit(user: User): Observable<any> {
    return this.repository.edit(user);
  }

  delete(item: any): Observable<any> {
    return this.repository.delete(item);
  }
}
